import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const slides = document.querySelectorAll('.products__slider .swiper-slide');

    let totalWidth = 0;
    slides.forEach((slide, index) => {
        totalWidth += slide.offsetWidth;

        const offset = index * -20;
        slide.style.transform = `translateX(${offset}px)`;
        slide.style.zIndex = slides.length + index;
    });

    const swiperOptions = {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        // spaceBetween: -20,
        slidesOffsetBefore: totalWidth <= (window.innerWidth - 40) ? 0 : 20,
        slidesOffsetAfter: totalWidth <= (window.innerWidth - 40) ? 0 : 20,
        centerInsufficientSlides: totalWidth <= (window.innerWidth - 40),
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            1240: {
                slidesOffsetBefore: totalWidth <= (window.innerWidth - 250) ? 0 : 125,
                slidesOffsetAfter: totalWidth <= (window.innerWidth - 250) ? 0 : 125,
                centerInsufficientSlides: totalWidth <= (window.innerWidth - 250),
            },
            768: {
                slidesOffsetBefore: totalWidth <= (window.innerWidth - 120) ? 0 : 60,
                slidesOffsetAfter: totalWidth <= (window.innerWidth - 120) ? 0 : 60,
                centerInsufficientSlides: totalWidth <= (window.innerWidth - 120),
            }
        }
    };

    element.swiper = new Swiper(element.querySelector(".products__slider"), swiperOptions);
};